import { MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { DropdownObject } from "../../utils/constants";
import { REGEX_COLOR_HEX } from "../../utils/regex";

interface Props {
  width?: string;
  background?: string;
  label?: string;
  required?: boolean;
  onSelected: (value: string) => void;
  dropdownItem: DropdownObject[];
}

const DropdownCommon = (props: Props) => {
  const {
    width = "100%",
    background,
    label,
    required,
    onSelected,
    dropdownItem,
  } = props;

  const [bgColor, setBgColor] = useState<string | undefined>(background);

  const handleChangeSelect = (e: any) => {
    const { value } = e.target;
    onSelected(value);
    if (value && REGEX_COLOR_HEX.test(value)) {
      setBgColor(value);
    }
  };

  return (
    <div style={{ marginBottom: "1rem" }}>
      {/* External label */}
      {label && (
        <label
          htmlFor="dropdown"
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            marginBottom: "0.5rem",
          }}
        >
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <Select
        id="dropdown"
        className="!font-forza"
        variant="outlined"
        sx={{
          width: `${width}`,
          height: 40,
          background: bgColor ?? "background.paper",
          border: "1px solid var(--app-border)",
          borderRadius: "8px",
          color: "text.primary",
          "& .MuiSvgIcon-root": {
            color: "text.primary",
          },
          "&:hover": {
            borderColor: "var(--app-text-muted)",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            display: "none",
          },
        }}
        onChange={handleChangeSelect}
        displayEmpty
      >
        {dropdownItem.map((item: DropdownObject, key) => (
          <MenuItem
            className={`!font-forza capitalize`}
            value={item.key}
            key={key}
            sx={{
              background: item.value,
              textTransform: "capitalize", // Capitalize menu item text
            }}
          >
            {item.value}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default DropdownCommon;
